import { useAuth } from 'lib/context';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { MeetingList } from './pages/MeetingList';
import { MeetingDetails } from './pages/MeetingDetails';

export const MeetingRoutes = () => {
  const { userData } = useAuth();
  const showLiveVideo = !!Number(userData.customer.liveAccess);
  return (
    <Switch>
      {showLiveVideo && (
        <>
          <Route path='/meetings' component={MeetingList} exact={true} />
          <Route
            path='/meetings/:meetingId'
            component={MeetingDetails}
            exact={true}
          />
          <Route path='/meetings/new' component={MeetingDetails} exact={true} />
        </>
      )}
    </Switch>
  );
};
